/* Los exámenes del 17 y 18 (23a): a qué hora (en Japón y en Madrid), dónde hacerlos y qué preparar.
   La víspera, la hoja se abre sola una vez. */
import type { Examen, Viaje } from '../datos/tipos.ts';
import { Documento } from '../componentes/Documento.tsx';
import { Hoja } from '../componentes/Hoja.tsx';
import { fechaCorta, hhmm, num2 } from '../texto.ts';

export function ListaExamenes({ v, examenes }: { v: Viaje; examenes: Examen[] }) {
  return (
    <div className="examenes">
      {examenes.map(e => {
        const d = v.dias[e.dia - 1];
        return (
          <article key={e.id} className="examen">
            <p className="examen__cuando"><span lang="ja">試</span> JP{num2(e.dia)} · {fechaCorta(d).toUpperCase()} · <b>{hhmm(e.ini)}</b> en Japón <small>({e.madrid.split('·').pop()!.trim()} en Madrid)</small></p>
            <p className="examen__que">{e.asignatura}</p>
            {e.sitio && <p className="texto">{e.sitio}</p>}
            {e.plan && <p className="examen__plan">Según el plan: {e.plan}</p>}
          </article>
        );
      })}
    </div>
  );
}

export function HojaExamenes({ v, dia, onCerrada }: { v: Viaje; dia: number; onCerrada: () => void }) {
  const examenes = v.examenes.filter(e => e.dia === dia);
  return (
    <Hoja id="hoja-examenes" titulo="examenes-titulo" onCerrada={onCerrada}>
      {() => (
        <>
          <p className="hoja__kicker">試験 · MAÑANA</p>
          <h2 id="examenes-titulo">{examenes.length === 1 ? 'Mañana tienes un examen' : `Mañana tienes ${examenes.length} exámenes`}</h2>
          <ListaExamenes v={v} examenes={examenes} />
          <Documento doc={v.documentos.examenes} secciones={v.documentos.examenes.secciones.filter(s => /conexi|antes/i.test(s.titulo)).map(s => s.id)} />
        </>
      )}
    </Hoja>
  );
}
